export default "50afff9a21b5af5d.png"